import {
  BarChartOutlined,
  ShopOutlined,
  AppstoreOutlined,
  ClusterOutlined,
  WarningOutlined,
} from "@ant-design/icons";

import {
  LineConfig,
  AreaConfig,
  ColumnConfig,
  Plot,
  PlotEvent,
} from "@ant-design/charts";

import {
  Alert,
  Button,
  Card,
  Col,
  Form,
  Popconfirm,
  Row,
  Select,
  Statistic,
  Image,
  Result,
} from "antd";

import axios from "axios";
import PropTypes from "prop-types";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import WholeLayout from "../layout/index";
import { authenticateToken } from "../../utils/auth";
import moment from "moment";
import { responseNotification } from "../../utils/notify";
import { debounce } from "lodash";
import OutOfStock from "../../images/out_of_stock.jpg";
const { Option } = Select;

// -------------------------

type Base = LineConfig | AreaConfig | ColumnConfig;

const PlotMaps: Record<string, Plot<Base>> = {};

let PreTooltipData: { date: string; value: number };
// -------------------------

const Dashboard = ({ userInfo }: any) => {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");
  const [type, setType] = useState("JC_MART");
  const [getTotalShop, setTotalShop] = useState(undefined);
  const [shopId, setShopId] = useState<any>();

  const [stockOutProduct, setStockOutProduct] = useState({
    loading: false,
    data: null,
  });

  const [stockOutActiveProduct, setStockOutActiveProduct] = useState({
    loading: false,
    data: null,
  });

  const [range, setRange] = useState({
    from: null,
    to: null,
  });
  const [orderData, setOrderData] = useState({
    loading: false,
    data: null,
  });
  const [hubData, setHubData] = useState({
    loading: false,
    data: null,
  });
  const [merchantData, setMerchantData] = useState({
    loading: false,
    data: null,
  });
  const [shopData, setShopData] = useState({
    loading: false,
    data: null,
  });
  const [shopsOptions, setShopsOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [data, setData] = useState([]);
  useEffect(() => {
    asyncFetch();
  }, []);
  const asyncFetch = () => {
    fetch("https://gw.alipayobjects.com/os/antvdemo/assets/data/sp500.json")
      .then((response) => response.json())
      .then((json) => setData(json))
      .catch((error) => {
        console.log("fetch data failed", error);
      });
  };
  const config = {
    data,
    xField: "date",
    yField: "price",
    height: 200,
  };

  const showTooltip = ({ x, y }: { x: number; y: number }) => {
    Object.keys(PlotMaps).forEach((plot) => {
      PlotMaps[plot].chart.showTooltip({ x, y });
    });
  };

  const setTooltipPosition = (evt: PlotEvent, plot: Plot<Base>) => {
    const { x, y } = evt.gEvent;
    const currentData = plot.chart.getTooltipItems({ x, y });
    if (currentData[0]?.data.date === PreTooltipData?.date) {
      return;
    }
    PreTooltipData = currentData[0]?.data;
    showTooltip({ x, y });
  };

  // **********************************************
  // **********************************************

  const onSubmit = async () => {
    setLoading(true);

    await fetch(
      `${process.env.REACT_APP_CATALOG_WRITER_API}/product/inactive-stock-out-product`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(``),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        setLoading(false);

        if (res.statusCode === 200) {
          getStockOutActiveProduct();
          responseNotification("Action Successfully Done!", "success");
        } else if (res.status === 500) {
          responseNotification("Internal server error", "error");
        } else {
          responseNotification(res.message || "something wrong", "warning");
        }
      })
      .catch((err) => {
        setLoading(false);
        responseNotification(`${"Internal server error"} ${err}`, "error");
        console.error("err", err);
      });
  };

  const getTotalHubs = useCallback(async () => {
    setHubData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;

    axios
      .get(
        `${encodedUri}/hub/all?page=0&limit=1` +
          (type ? `&type=${type}` : ``) +
          (status ? `&status=${status}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setHubData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setHubData({ loading: false, data: [] });
        console.error("Shop: Error", err);
      });
  }, []);

  const getTotalMerchants = useCallback(async () => {
    setMerchantData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;

    axios
      .get(
        `${encodedUri}/merchant/all?page=0&limit=1` +
          (type ? `&type=${type}` : ``) +
          (status ? `&status=${status}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setMerchantData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setMerchantData({ loading: false, data: [] });
        console.error("Shop: Error", err);
      });
  }, []);

  const getTotalShops = useCallback(async () => {
    setShopData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;

    axios
      .get(
        `${encodedUri}/admin/shop?page=0&limit=1` +
          (type ? `&type=${type}` : ``) +
          (status ? `&status=${status}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setShopData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setShopData({ loading: false, data: [] });
        console.error("Shop: Error", err);
      });
  }, []);

  const getTotalOrders = useCallback(
    async (st) => {
      const from = moment(range.from)?.toISOString();
      const to = moment(range.to)?.toISOString();
      const encodedUri = `${process.env.REACT_APP_ORDER_API}`;

      if (shopId) {
        return axios
          .get(
            `${encodedUri}/admin/order/by-shop?page=0&limit=1` +
              (shopId ? `&shopId=${shopId}` : ``) +
              // (type ? `&type=${type}` : ``) +
              (st ? `&status=${st}` : ``) +
              (from ? `&from=${from}` : ``) +
              (to ? `&to=${to}` : ``),
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
              },
            }
          )
          .then((res) => {
            return res;
          })
          .catch((err) => {
            console.error("Category: Error", err);
          });
      } else {
        return axios
          .get(
            `${encodedUri}/admin/order?page=0&limit=1` +
              (st ? `&status=${st}` : ``) +
              (type ? `&type=${type}` : ``) +
              (from ? `&from=${from}` : ``) +
              (to ? `&to=${to}` : ``),
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
              },
            }
          )
          .then((res) => {
            return res;
          })
          .catch((err) => {
            console.error("Category: Error", err);
          });
      }
    },
    [shopId]
  );

  const orderStatus = [
    `INITIATED`,
    // `COMPLETED`,
    // `DELIVERED`,
    `REVIEWED`,
    `CANCELLED`,
  ];
  let statusReqsts = orderStatus.map((status) => {
    return getTotalOrders(status);
  });

  useEffect(() => {
    // setShopName();
    setOrderData({
      loading: true,
      data: [],
    });
    Promise.allSettled(statusReqsts).then((results) =>
      setOrderData({
        loading: false,
        data: results.map((result: any) => result?.value?.data),
      })
    );
  }, [shopId]);

  // get total Shop
  const getShopsOptions = useCallback(
    async (val?: string) => {
      setShopsOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/shop/admin/search?page=0&limit=10` +
          (val ? `&key=${val}` : ``) +
          (type ? `&type=${type}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setShopsOptions({
        loading: false,
        list: res?.data?.shops?.map((shop) => {
          return {
            id: shop?.id,
            name: shop?.name,
          };
        }),
      });
    },
    [type]
  );

  // Get Out of stock products

  const getStockOutProduct = useCallback(() => {
    try {
      setStockOutProduct({ loading: true, data: undefined });
      axios
        .get(
          `${process.env.REACT_APP_CATALOG_READER_API}/admin/product/stock-out-products?` +
            `page=${0}` +
            `&limit=${16}`,
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((data) => {
          if (data.status === 200) {
            setStockOutProduct({
              loading: false,
              data: data?.data,
            });
          } else {
            setStockOutProduct({ loading: false, data: null });
            responseNotification(
              data.statusText || "something went wrong",
              "error"
            );
          }
        })
        .catch((err) => {
          setStockOutProduct({ loading: false, data: null });

          console.log(err);
        });
    } catch (error) {
      setStockOutProduct({ loading: false, data: null });

      console.log(error, "error");
    }
  }, []);

  const getStockOutActiveProduct = useCallback(() => {
    try {
      setStockOutActiveProduct({ loading: true, data: undefined });
      axios
        .get(
          `${process.env.REACT_APP_CATALOG_READER_API}/admin/product/stock-out-products?deleted=false&isActive=true` +
            `&page=${0}` +
            `&limit=${16}`,
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((data) => {
          if (data.status === 200) {
            setStockOutActiveProduct({
              loading: false,
              data: data?.data,
            });
          } else {
            setStockOutActiveProduct({ loading: false, data: null });
            responseNotification(
              data.statusText || "something went wrong",
              "error"
            );
          }
        })
        .catch((err) => {
          setStockOutActiveProduct({ loading: false, data: null });

          console.log(err);
        });
    } catch (error) {
      setStockOutActiveProduct({ loading: false, data: null });

      console.log(error, "error");
    }
  }, []);
  // *****************

  const fetchRef = useRef(null);
  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      if (type) {
        if (value) {
          if (field === "shop") getTotalShop(value);
        }
      } else {
        responseNotification("Select a type before search", "warning");
      }
    };

    return debounce(loadOptions, 800);
  }, [getTotalShop, type]);

  useEffect(() => {
    getStockOutProduct();
    getStockOutActiveProduct();
    getTotalHubs();
    getTotalMerchants();
    getShopsOptions();
    getTotalShops();
  }, [
    getStockOutProduct,
    getStockOutActiveProduct,
    getShopsOptions,
    getTotalShops,
    getTotalMerchants,
    getTotalHubs,
  ]);

  return (
    <WholeLayout>
      <div className="main-dashboard-page overflowY">
        <div className="container-fluid">
          {/* Total Order History */}
          <Row gutter={20} className="mb-5">
            <Col span={8}>
              <Card>
                <Statistic
                  title="Total Hub"
                  value={hubData?.data?.totalElements}
                  prefix={<AppstoreOutlined />}
                />
              </Card>
            </Col>
            <Col span={8}>
              <Card>
                <Statistic
                  title="Total Merchant"
                  value={merchantData?.data?.totalElements}
                  prefix={<ClusterOutlined />}
                />
              </Card>
            </Col>
            <Col span={8}>
              <Card>
                <Statistic
                  title="Total Shop"
                  value={shopData?.data?.totalElements}
                  prefix={<ShopOutlined />}
                />
              </Card>
            </Col>
          </Row>

          {/* Total Order History */}
          <div className="site-statistic-demo-card mb-4">
            <div className="title d-flex justify-content-between align-items-center">
              <h4 className="mb-0 text-uppercase">
                Order History
                {/* {shopName ? shopName : "ALL SHOP"} */}
              </h4>
              <div className="">
                <Form.Item name="shop_search" className="mb-0">
                  <Select
                    size="small"
                    showSearch
                    allowClear
                    placeholder="Filter by Shop"
                    optionFilterProp="children"
                    onChange={(val) => {
                      setShopId(val);
                      // setShopName(
                      //   shopsOptions.list?.find((name) => (name.id = val))?.name
                      // );
                    }}
                    onSearch={(e) => handleSearch(e, "shop")}
                    filterOption={(input, option) =>
                      option.children
                        .toString()
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    style={{ minWidth: 250 }}
                  >
                    {shopsOptions.list.length ? (
                      <Option value={null}>All Orders</Option>
                    ) : undefined}
                    {shopsOptions.list.map((shop, i) => (
                      <Option value={shop.id} key={i}>
                        {shop.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
            </div>
            <Row gutter={[20, 20]}>
              {orderData?.data?.map((item, i) => (
                <Col span={8} key={i}>
                  <Card>
                    <Statistic
                      title={`TOTAL ${orderStatus[i]}`}
                      value={item?.totalElements}
                      precision={0}
                      valueStyle={{ color: "#3f8600" }}
                      prefix={<BarChartOutlined />}
                    />
                  </Card>
                </Col>
              ))}
            </Row>
          </div>

          <Row gutter={20}>
            <Col span={8}>
              <Card
                cover={
                  stockOutActiveProduct?.data?.totalElements > 0 && (
                    <Image
                      src={OutOfStock}
                      placeholder="Out of Stock"
                      preview={false}
                    />
                  )
                }
              >
                {stockOutActiveProduct?.data?.totalElements > 0 ? (
                  <>
                    <Alert
                      message={`Currently, about
               ${stockOutProduct?.data?.totalElements} products are out of stock.`}
                      description="If you want to INACTIVE out of stock product,
                  you just hit this button and Confirm to Inactive."
                      style={{ marginBottom: 25 }}
                      type="warning"
                    />
                    <Popconfirm
                      title={
                        "Are you Sure to Inactive all Out of Stock Product? "
                      }
                      onConfirm={() => onSubmit()}
                      okText="Confirm"
                      okButtonProps={{ loading: loading }}
                    >
                      <Button type="dashed" block>
                        <span className="d-flex">
                          <WarningOutlined className="mr-2" /> ACTION
                        </span>
                      </Button>
                    </Popconfirm>
                  </>
                ) : (
                  <Result
                    status="404"
                    title="Need to increase stock!"
                    subTitle={`Currently, about
                    ${stockOutProduct?.data?.totalElements} products are OUT OF STOCK.
                    `}
                    // extra={<Button type="primary">Back Home</Button>}
                  />
                )}
              </Card>
            </Col>

            <Col span={8}>
              <div className="user-profile-wrapper text-center">
                <div className="inner-wrapper">
                  <div className="avatar-role">
                    <div className="user-avatar">
                      <img
                        src="https://www.kindpng.com/picc/m/78-786207_user-avatar-png-user-avatar-icon-png-transparent.png"
                        alt="avatar"
                      />
                    </div>
                    <div className="role">
                      <h4>{userInfo.role}</h4>
                    </div>
                  </div>
                  <div className="user-content">
                    <h3>{userInfo ? userInfo?.name : ""}</h3>
                    <h4>{userInfo ? userInfo?.email : ""}</h4>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          {/* <Row gutter={20} className="mb-5">
            <Col span={8}>
              <Card title="Chart View">
                <Line
                  {...config}
                  onReady={(plot) => {
                    PlotMaps.line = plot;
                    plot.on("mousemove", (evt: PlotEvent) => {
                      setTooltipPosition(evt, plot);
                    });
                  }}
                />
              </Card>
            </Col>
            <Col span={8}>
              <Card title="Chart View">
                <Area
                  {...config}
                  onReady={(plot) => {
                    PlotMaps.area = plot;
                    plot.on("mousemove", (evt: PlotEvent) => {
                      setTooltipPosition(evt, plot);
                    });
                  }}
                />
              </Card>
            </Col>
            <Col span={8}>
              <Card title="Chart View">
                <Column
                  {...config}
                  onReady={(plot) => {
                    // @ts-ignore
                    PlotMaps.Column = plot;
                    plot.on("mousemove", (evt: PlotEvent) => {
                      // @ts-ignore
                      setTooltipPosition(evt, plot);
                    });
                  }}
                />
              </Card>
            </Col>
          </Row> */}
        </div>
      </div>
    </WholeLayout>
  );
};
Dashboard.propTypes = {
  userInfo: PropTypes.object,
};
const mapStateTopProps = (state: { authReducer: { role: any } }) => {
  return { userInfo: state.authReducer };
};
export default connect(mapStateTopProps, null)(Dashboard);
